import { useEffect, useState } from 'react';

const STORAGE_KEY = 'limu_theme';

export function useTheme(defaultTheme) {
  const [theme, setTheme] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'light' || stored === 'dark') return stored;
    } catch {}
    return defaultTheme || 'dark';
  });

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, theme); } catch {}
  }, [theme]);

  return [theme, setTheme];
}
